import { Provider as ProviderEnum } from '@/constants';

import Provider from './provider';

export class SSOProvider extends Provider {
  constructor(authUrl: string, clientId: string) {
    super(ProviderEnum.SSO, authUrl, clientId);
  }
}
